import { WebUiScopeType } from "@intelligems/ig-types";

// Useful for debugging
// Make everything disabled
export const FEATURE_TOGGLE_GLOBAL_DEBUG = true;

// Set to false to see features as a 'member'
export const ADMINS_HAVE_FULL_ACCESS = true;

export const UPGRADE_MESSAGES = {
  UPGRADE: "Approve and upgrade your plan so you can start this experiment.",
  SCHEDULE_ONBOARDING: "Schedule your onboarding to create this experiment.",
  CANCELLED: "Re-enable billing to continue price testing.",
};

export const CREATE_SHIPPING_EXPERIMENT_BUTTON: WebUiScopeType[] = [
  "create_shipping_experiment",
];

export const CREATE_CONTENT_EXPERIMENT_BUTTON: WebUiScopeType[] = [
  "create_content_experiment",
];

export const CREATE_PRICING_EXPERIMENT_BUTTON: WebUiScopeType[] = [
  "create_price_experiment",
];

export const CREATE_DISCOUNT_EXPERIMENT_BUTTON: WebUiScopeType[] = [
  "personalizations",
];
